import dynamic from "next/dynamic";
const CardDots = dynamic(
  () => import("@/Components/DataDisplayCompoants/CardDots"),
  { ssr: false }
);

interface CardsProps {
  counter: string;
  details: string;
  className?: string;
  classNameDot?: string;
}
const Cards: React.FC< CardsProps> = ({ counter,
  details,
  className,
  classNameDot,
 }) => {
  return (
    <div
      className={`bg-[#0404041A] border border-[#D6EEFF]/30 lg:p-6 p-4 lg:aspect-square aspect-[191_/_179] overflow-hidden h-auto flex flex-col justify-end items-start relative
        after:bg-[url(/images/slider/blue-slide.png)] after:content-[''] after:absolute after:lg:w-[94px] after:w-[44px] after:lg:h-[191px] after:h-[80px] after:max-h-full after:top-0 after:right-0 after:bg-contain after:bg-no-repeat after:bg-right-bottom after:opacity-0
        before:bg-[url(/images/slider/blue-shard.svg)] before:will-change-transform before:content-[''] before:absolute before:w-full before:h-full before:top-0 before:left-0 before:bg-cover before:bg-no-repeat before:bg-center
        transition-all duration-200 before:opacity-0
         ${className}
      `}
    >
      <div className={`${classNameDot}`}>
        <CardDots />
      </div>
      <div className="relative z-10">
        <h2 className="text-heading-2 font-bold">{counter}</h2>
        <p className="sm:text-subtitle-2 text-subtitle-3 font-regular mt-2 md:line-clamp-4 line-clamp-3">
          {details}
        </p>
      </div>
    </div>
  );
};
export default Cards;